import { ProductsTabTranslations } from "#i18n/translations/pt-BR/org/products/products-tab";

export const ORG_PRODUCTS_TAB_ES_ES: ProductsTabTranslations = {
	label: "Registro base de producto",
	description:
		"Lista de productos registrados en la organización y su información basal.",
	header: {
		counter: "{{amount}} Productos",
		search: "Buscar",
		add: "Agregar producto",
		inventory: "Modificar inventario",
		export: "Exportar productos",
		addPlaces: "Agregar locales",
		editPlaces: "Editar locales",
		deleteProduct: "Eliminar (1) producto",
		deleteMultipleProducts: "Eliminar ({{products}}) productos",
	},
	addEditProductModal: {
		add: "Agregar producto",
		update: "Actualizar producto",
		edit: "Editar producto",
		undefined: "Indefinido",
		unavailable: "No disponible",
		form: {
			name: {
				label: "Nombre del Producto",
				placeholder: "Ingrese un nombre para el producto",
				error: "Use solo caracteres válidos",
			},
			type: {
				label: "Tipo",
				placeholder: "Seleccione un tipo de producto",
			},
			category: {
				label: "Categoría",
				info: "Estará creando una nueva categoría",
				placeholder: "Seleccione o cree una categoría",
				error: "Elija o cree una categoría",
			},
			code: {
				label: "SKU",
				placeholder: "Ingrese un SKU",
				tooltip: "Si no se completa, el código se generará automáticamente",
				error: "El SKU no puede contener el carácter #",
			},
			ncm: {
				label: "NCM",
				placeholder: "Ingrese un NCM",
				error: "El NCM debe tener 8 dígitos",
			},
			photo: "Foto",
			hasAlcohol: "¿Contiene alcohol?",
			error: "Este campo es obligatorio",
		},
	},
	inventoryUpdate: {
		label: "Modificar inventario",
		import: "Importar hoja",
		download: "Descargar hoja",
		columns: {
			id: "Id del producto",
			name: "Nombre",
			category: "Categoría",
			type: "Tipo de producto",
			hasAlcohol: "¿Contiene alcohol?",
			fiscalCode: "SKU",
			fiscalNcm: "Fiscal - NCM",
		},
	},
	exportProducts: {
		products: "Productos",
		warningNotification: "Productos no modificados",
		columns: {
			id: "Id del producto",
			title: "Nombre",
			category: "Categoría",
			places: "Locales",
			fiscalNcm: "NCM",
			fiscalCode: "SKU",
			systemProduct: "Producto de sistema",
			type: "Tipo",
			hasAlcohol: "¿Contiene alcohol?",
			description: "Descripción",
		},
	},
	productForm: {
		required: "Este campo es obligatorio",
		alcoholLabel: "¿Contiene alcohol?",
		categoryLabel: "Categoría",
		categoryPlaceholder: "Ingrese la categoría del producto",
		createProduct: "Crear producto de inventario",
		editProduct: "Editar producto de inventario",
		fiscalCodelabel: "SKU",
		fiscalCodePlacehodler: "Ingrese el código SKU del producto",
		fiscalCodeError: "Solo números, puntos y letras",
		ncmLabel: "NCM",
		ncmPlaceholder: "Ingrese el código NCM del producto",
		photolabel: "Foto",
		productNameLabel: "Nombre del producto",
		productNamePlaceholder: "Ingrese el nombre del producto",
		placesLabel: "Locales",
		placesPlaceholder: "Seleccione los locales del producto",
		price: "Precio",
		priceTooltip:
			"El cambio del precio en este campo modifica el precio del producto para todos los locales vinculados",
		editPrice: "Modificar precio",
		saveEditProduct: "Guardar cambios",
		saveProduct: "Guardar producto",
		confirmProductPrice: {
			goBack: "Volver a edición",
			confirm: "Confirmar cambio",
			title: "Confirmar ajuste",
			description: {
				title: "¿Desea confirmar el cambio de precio?",
				subtitle:
					"Los locales vinculados pasarán a tener el nuevo valor de <b>{{productValue}}</b> para el producto <b>{{productName}}.</b>",
			},
		},
	},
	validation: {
		systemProduct: {
			required: "El producto del sistema es obligatorio",
		},
	},
	types: {
		product: "Producto",
		supply: "Insumo",
	},
	rows: {
		products: "Productos",
		type: "Tipo",
		places: "Locales",
		noProducts: "Sin productos",
		fiscalCode: "SKU",
	},
	selectPlaces: {
		label: "Seleccionar locales",
		search: "Buscar locales",
	},
	removeProduct: {
		label: "Eliminar producto",
		title: "¿Realmente desea eliminar el producto?",
	},
	modalDelete: {
		title: "Eliminar producto",
		description:
			"Al confirmar la acción, eliminará permanentemente el producto. ¿Desea continuar?",
	},
	modalDeleteMultipleProducts: {
		title: "Eliminar productos",
		description:
			"Al eliminar los productos seleccionados, serán excluidos de todos los locales y no será posible revertir esta acción.",
		confirm: "¿Desea eliminar de todos modos?",
	},
	link: "Vínculo",
	links: "Vínculos",
	productPlacesModal: {
		title: "Vínculos del producto",
		description: "Relación de locales donde el producto está presente",
		seePlace: "Ver local",
	},
};
